module.exports = __webpack_public_path__ + "media/images/home-bg-958f703e1b8dd5eabb84e87c8d4209d0.svg";